<template>
  <div class="page-container">
    <h1 class="page-title">关于我们</h1>
    
    <div class="content-section">
      <h2 class="section-title">公司简介</h2>
      <p class="section-text">
        新疆音线信息科技有限公司是一家成立于2025年03月25日的其他有限责任公司，属于以从事信息传输、软件和信息技术服务业为主的企业。公司注册地位于新疆乌鲁木齐市经济技术开发区(头屯河区)通达街767号安澜大厦公寓1516室。其法定代表人为艾海提·米吉提，注册资本为500万(元)，所属行业为软件和信息技术服务业。公司的经营范围包括软件开发、网络与信息安全软件开发、云计算装备技术服务、互联网数据服务、数据处理服务等。
      </p>
      <p class="section-text">
        公司拥有专业的技术团队和丰富的音乐资源，通过创新的技术手段和精准的内容运营，不断提升用户体验，推动音乐文化的传播与发展。同时，公司积极响应国家文化产业政策，深入挖掘民族音乐资源，促进传统音乐与现代技术的融合，为中华优秀传统文化的传承与创新贡献力量。
      </p>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">企业使命</h2>
      <div class="mission-vision">
        <div class="mission-item">
          <h3 class="mission-title">使命</h3>
          <p class="mission-desc">连接音乐与人心，传播美好与感动</p>
        </div>
        <div class="mission-item">
          <h3 class="mission-title">愿景</h3>
          <p class="mission-desc">成为最受信赖的音乐文化传播平台</p>
        </div>
        <div class="mission-item">
          <h3 class="mission-title">价值观</h3>
          <p class="mission-desc">诚信、创新、共享、责任</p>
        </div>
      </div>
    </div>
    
    <!-- <div class="content-section">
      <h2 class="section-title">发展历程</h2>
      <div class="timeline">
        <div class="timeline-item">
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <h3 class="timeline-title">2025年3月</h3>
            <p class="timeline-desc">新疆音线信息科技有限公司正式成立</p>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <h3 class="timeline-title">2025年4月</h3>
            <p class="timeline-desc">完成天使轮融资，获得知名投资机构支持</p>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <h3 class="timeline-title">2025年5月</h3>
            <p class="timeline-desc">新疆音线平台1.0版本上线，正式对外提供服务</p>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <h3 class="timeline-title">2025年6月</h3>
            <p class="timeline-desc">用户数突破100万，成为西北地区最大的音乐平台</p>
          </div>
        </div>
        
        <div class="timeline-item">
          <div class="timeline-dot"></div>
          <div class="timeline-content">
            <h3 class="timeline-title">2025年7月</h3>
            <p class="timeline-desc">平台2.0版本上线，全面升级用户体验</p>
          </div>
        </div>
      </div>
    </div> -->
    
    <div class="content-section">
      <h2 class="section-title">团队介绍</h2>
      <p class="section-text">
        新疆音线拥有一支年轻、专业、充满活力的团队，成员来自国内知名互联网公司和音乐行业。团队核心成员均拥有丰富的行业经验和专业背景，在技术研发、产品设计、内容运营等方面具备深厚的积累和创新能力。
      </p>
    </div>
    
    <div class="content-section">
      <h2 class="section-title">联系我们</h2>
      <div class="contact-info">
        <p><strong>公司地址：</strong>新疆乌鲁木齐市经济技术开发区(头屯河区)通达街767号安澜大厦公寓1516室</p>
        <p><strong>联系电话：</strong>15160945581</p>
        <p><strong>电子邮箱：</strong>2756825623@qq.com</p>
        <p><strong>官方网站：</strong>subat.tv</p>
        <p><strong>工作时间：</strong>周一至周五 9:00-18:00（法定节假日除外）</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AboutUs'
}
</script>

<style scoped>
.page-container {
  padding: 20px;
  max-width: 1000px;
  margin: 0 auto;
  padding-bottom: 40px;
}

.page-title {
  font-size: 24px;
  font-weight: 500;
  margin-bottom: 30px;
  color: #333;
  border-bottom: 1px solid #eee;
  padding-bottom: 10px;
}

.content-section {
  margin-bottom: 30px;
}

.section-title {
  font-size: 18px;
  font-weight: 500;
  margin-bottom: 15px;
  color: #333;
}

.section-text {
  font-size: 14px;
  line-height: 1.8;
  color: #333;
  margin-bottom: 15px;
  text-align: justify;
}

.mission-vision {
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.mission-item {
  flex: 1;
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 20px;
  margin: 0 10px;
  text-align: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.mission-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 10px;
  color: #4169e1;
}

.mission-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.timeline {
  position: relative;
  padding-left: 30px;
  margin-top: 20px;
}

.timeline::before {
  content: '';
  position: absolute;
  left: 7px;
  top: 0;
  height: 100%;
  width: 2px;
  background-color: #eee;
}

.timeline-item {
  position: relative;
  margin-bottom: 25px;
}

.timeline-dot {
  position: absolute;
  left: -30px;
  top: 5px;
  width: 16px;
  height: 16px;
  border-radius: 50%;
  background-color: #4169e1;
  z-index: 1;
}

.timeline-content {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 15px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.timeline-title {
  font-size: 16px;
  font-weight: 500;
  margin-bottom: 5px;
  color: #4169e1;
}

.timeline-desc {
  font-size: 14px;
  line-height: 1.6;
  color: #333;
}

.contact-info {
  background-color: #f9f9f9;
  border-radius: 4px;
  padding: 20px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.contact-info p {
  margin-bottom: 10px;
  font-size: 14px;
  line-height: 1.6;
}

@media (max-width: 768px) {
  .mission-vision {
    flex-direction: column;
  }
  
  .mission-item {
    margin: 0 0 15px 0;
  }
}
</style> 